import { useState, useEffect } from "react";
import { getDateUtil, today } from "../../util/formatDate";
import { postAxios } from "../../util/apiCall";

export const useMold = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [companyPickList, setCompanyPickList] = useState("GS");
  const [dataListMold, setDataListMold] = useState();
  const [popUpDeleteMold, setPopUpDeleteMold] = useState(false);
  const [popUpEditMold, setPopUpEditMold] = useState(false);
  const [isApiRefresh, setIsApiRefresh] = useState(false);
  const [popUpTambahMold, setPopUpTambahMold] = useState(false);
  const [dataListDelete, setDataListDelete] = useState();

  const [newMold, setNewMold] = useState("");
  const [newMoldColor, setNewMoldColor] = useState("");
  const [companyNewMold, setCompanyNewMold] = useState("");
  const [newTargetProduk, setNewTargetProduk] = useState("");
  const [editNamaMold, setEditNamaMold] = useState("");
  const [editColorMold, setEditColorMold] = useState("");
  const [editBerat, setEditBerat] = useState();

  const [material, setMaterial] = useState("");
  const [targetProduk, setTargetProduk] = useState();
  const [total, setTotal] = useState();

  const [valueSearch, setValueSearch] = useState("");

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListMold`,
      { tim: dataUser.tim },
      dataUser.auth,
      setDataListMold,
      ""
    );
    setIsApiRefresh(false);
  }, [isApiRefresh]);

  const dataPick = () => {
    let data;
    dataListMold &&
      dataListMold.forEach((element) => {
        if (element.company === companyPickList) {
          data = element;
        }
      });
    return data;
  };

  const MoldList = dataPick();

  const handleDeleteMold = async () => {
    const merge = {
      company: companyPickList,
      type: "delete",
      tim: dataUser.tim,
      ...dataListDelete,
    };

    await postAxios(
      `${process.env.REACT_APP_ENDPOINT}/deleteMold`,
      merge,
      dataUser.auth,
      "",
      ""
    );
    setIsApiRefresh(true);
    setPopUpDeleteMold(false);
  };

  const handleEditMold = async () => {
    const merge = {
      company: companyPickList,
      date: getDateUtil(today),
      type: "edit",
      tim: dataUser.tim,
      editMoldName: editNamaMold,
      editMoldColor: editColorMold,
      editMaterial: material,
      editTotal: Number(total),
      newTargetProduk: Number(newTargetProduk),
      editBerat: Number(editBerat),
      ...dataListDelete,
    };

    await postAxios(
      `${process.env.REACT_APP_ENDPOINT}/deleteMold`,
      merge,
      dataUser.auth,
      "",
      ""
    );
    setIsApiRefresh(true);
    setPopUpEditMold(false);
  };

  const handleKirimNewMold = () => {
    if (newMoldColor !== "" && newMold !== "" && companyNewMold !== "") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/addNewMold`,
        {
          tim: dataUser.tim,
          company: companyNewMold,
          name: newMold,
          color: newMoldColor,
          material: material,
          targetProduk: Number(targetProduk),
          total: Number(total),
        },
        dataUser.auth,
        setDataListMold,
        ""
      );

      setPopUpTambahMold(false);
      setNewMoldColor("");
      setNewMold("");
      setCompanyNewMold("");
      setMaterial("");
      setTargetProduk();
      setTotal();
      setIsApiRefresh(true);
    }
  };

  const searchFeature = (params) => {
    if (valueSearch !== "") {
      let searchName = [];
      MoldList &&
        MoldList.data.forEach((value) => {
          if (value.name.toLowerCase().includes(params.toLowerCase())) {
            searchName.push(value);
          }
        });
      return searchName;
    } else {
      return MoldList && MoldList.data;
    }
  };
  let dataTemp = searchFeature(valueSearch);

  return {
    dataUser,
    companyPickList,
    setCompanyPickList,
    MoldList,
    setDataListDelete,
    popUpDeleteMold,
    setPopUpDeleteMold,
    handleDeleteMold,
    handleEditMold,
    popUpEditMold,
    setPopUpEditMold,
    popUpTambahMold,
    setPopUpTambahMold,
    dataListMold,
    handleKirimNewMold,
    newMold,
    setNewMold,
    newMoldColor,
    setNewMoldColor,
    companyNewMold,
    setCompanyNewMold,
    setNewTargetProduk,
    newTargetProduk,
    editNamaMold,
    setEditNamaMold,
    editColorMold,
    setEditColorMold,
    material,
    setMaterial,
    targetProduk,
    setTargetProduk,
    total,
    setTotal,
    editBerat,
    setEditBerat,
    valueSearch,
    setValueSearch,
    dataTemp,
  };
};
